import { IconPlus, IconX } from "../../../components/icons";
import {
  collectPersonalDataTypes,
  personalDataTypeLabel,
} from "../../../lib/formBuilder/privacySuggestion";

interface PrivacySuggestionBannerProps {
  onAdd: () => void;
  onDismiss: () => void;
  detectedTypes: ReturnType<typeof collectPersonalDataTypes>;
}

export function PrivacySuggestionBanner({
  onAdd,
  onDismiss,
  detectedTypes,
}: PrivacySuggestionBannerProps) {
  const typesLabel = detectedTypes.map(personalDataTypeLabel).join(", ");

  return (
    <div className="rounded-xl border border-brand-200 bg-brand-50/60 p-3 sm:p-4">
      <div className="flex items-start gap-3">
        <div className="min-w-0 flex-1">
          <p className="font-onest text-sm font-semibold text-brand-900">
            Добавьте согласие на обработку данных
          </p>
          <p className="mt-1 font-onest text-xs leading-relaxed text-brand-900/80">
            В форме есть поля персональных данных ({typesLabel}). Для таких форм
            нужен чекбокс согласия — его можно добавить одним нажатием.
          </p>
          <button
            type="button"
            onClick={onAdd}
            className="mt-2.5 inline-flex items-center gap-1.5 rounded-lg bg-brand-500 px-3 py-1.5 font-onest text-xs font-medium text-white shadow-sm transition-colors hover:bg-brand-600"
          >
            <IconPlus size={14} />
            Добавить поле согласия
          </button>
        </div>
        <button
          type="button"
          title="Скрыть подсказку"
          aria-label="Скрыть подсказку"
          onClick={onDismiss}
          className="shrink-0 rounded-md p-1 text-brand-700/70 transition-colors hover:bg-brand-100 hover:text-brand-900"
        >
          <IconX size={16} />
        </button>
      </div>
    </div>
  );
}
